module.exports = __webpack_public_path__ + "img/aermod-option1.ac02f965.jpg";